import React, { useCallback } from 'react';
import * as c from '../../ts/const';
import ImgPicture from '../components/img-picture';
import { sendGtag } from '../../ts/modules/sendgtag';
const BeginnerBanner = () => {
    const onClick = useCallback(() => {
        sendGtag(`SPECIAL_BANNER`, c.IS_DEV);
    }, []);
    return (React.createElement("div", { className: 'banner sm:gutter' },
        React.createElement("a", { href: "https://www.jp.square-enix.com/digitalspecial/Guide/?utm_source=2023MARCHSALE&utm_medium=saleLP&utm_campaign=2023MARCHSALE", onClick: onClick, target: "_blank" },
            React.createElement(ImgPicture, { fileName: './assets/img/banner/beginner-desk', ext: 'png', alt: '\u30B2\u30FC\u30E0\u6848\u5185\u6240' })),
        React.createElement("div", { className: 'banner__text md:text-center' },
            React.createElement("div", null, "\u203B\u30BB\u30FC\u30EB\u5BFE\u8C61\u5916\u306E\u30BF\u30A4\u30C8\u30EB\u3082\u7D39\u4ECB\u3057\u3066\u3044\u307E\u3059\u3002"))));
};
export default BeginnerBanner;
